import * as React from 'react';

const Fr24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#ED2939", d: "M15 18V6h4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M9 18h6V6H9z" }), /* @__PURE__ */ React.createElement("path", { fill: "#002395", d: "M3 16V8a2 2 0 0 1 2-2h4v12H5a2 2 0 0 1-2-2" }));
Fr24.Size = 24;
Fr24.Title = "Fr";

export { Fr24 as default };
